import { WbUserPreferenceRow } from '@mst-fe/shared';

import { SignedInUser } from '../../../services/auth';
import { ErrorNotification } from '../../../services/error-notification';
import { UsersApi } from '../../users/users-api';
import { AddGitlabApiKeyModel } from './add-gitlab-api-key';
import { GenerateApiKeyModel } from './generate-api-key';
import { UserPreferencesModalModel } from './user-preferences';

export const USERNAME_ITEM_KEY = 'username';

export const EMAIL_ITEM_KEY = 'email';

export const LOGOUT_ITEM_KEY = 'logout';

export const API_GEN_ITEM_KEY = 'generateApi';

export const SUPPORT_MENU_ITEM_KEY = 'supportMenuItem';

export const ABOUT_MENU_ITEM_KEY = 'aboutMenuItem';

export const ADD_GITLAB_API_KEY = 'addGitlabApiKey';

export const USER_PREFERENCES_KEY = 'userPreferences';

export const USAGE_KEY = 'usage';

export interface UserInfoModel {
  loading: boolean;
  checkInFailed: boolean;
  user?: SignedInUser;
  preferences?: Omit<WbUserPreferenceRow, 'userSubject'>;
  isMidasPeer: boolean;
  workbenchAllowed: boolean;
  isAdmin: boolean;
  isLsegUser: boolean;
  generateApiKey: GenerateApiKeyModel | undefined;
  addGitlabApiKey: AddGitlabApiKeyModel | undefined;
  /**
   * Only used to show the User Preferences modal.
   * Should _not_ be used as a cache of preferences for the current user (found out the hard way).
   */
  userPreferencesModal: UserPreferencesModalModel | undefined;
  featureFlags: Set<string>;
}

export function initialUserInfo(): UserInfoModel {
  return {
    loading: true,
    checkInFailed: false,
    user: undefined,
    generateApiKey: undefined,
    addGitlabApiKey: undefined,
    userPreferencesModal: undefined,
    isMidasPeer: false,
    workbenchAllowed: false,
    isLsegUser: false,
    isAdmin: false,
    featureFlags: new Set(),
  };
}

export async function checkInUser(
  api: UsersApi,
  getModel: () => UserInfoModel,
  update: (_: UserInfoModel) => void
): Promise<ErrorNotification | undefined> {
  try {
    const res = await api.checkIn();

    if (!res?.ok) {
      update({
        ...getModel(),
        loading: false,
        checkInFailed: true,
      });
      return { message: 'Failed to check in' };
    }

    update({
      ...getModel(),
      loading: false,
      checkInFailed: false,
      featureFlags: new Set(res.featureFlags),
      workbenchAllowed: res.workbenchAllowed,
      isLsegUser: res.isLsegUser,
      isAdmin: res.isAdmin,
      preferences: res.userPreferences,
    });
  } catch {
    update({
      ...getModel(),
      loading: false,
      checkInFailed: true,
    });
    return { message: 'Failed to check in' };
  }
}
